import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

const state = () => ({
  mediaLoading: false,
  mediaList: [],
  medias: {},
  error: {},
  mediasWithInvalidName: [],
  suggestions: [],
});

export default {
  mutations,
  actions,
  getters,
  state,
};
